import { render, staticRenderFns } from "./Crossword.vue?vue&type=template&id=68c173a6&scoped=true"
import script from "./Crossword.vue?vue&type=script&lang=ts"
export * from "./Crossword.vue?vue&type=script&lang=ts"
import style0 from "./Crossword.vue?vue&type=style&index=0&id=68c173a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c173a6",
  null
  
)

export default component.exports